export default __webpack_public_path__ + "static/media/doctor3.6934dfd1.png";